import React, { useEffect, useState } from "react";
import Input from "./InputTypes/Input";

const FormPreview = ({ formConfig }) => {
  const [formData, setFormData] = useState(
    formConfig &&
      formConfig.fields.reduce((acc, field) => {
        acc[field.attributes.name] = field.attributes.value || "";
        return acc;
      }, {})
  );

  const handleChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  useEffect(() => {
    setFormData(
      formConfig &&
        formConfig.fields.reduce((acc, field) => {
          acc[field.attributes.name] = field.attributes.value || "";
          return acc;
        }, {})
    );
  }, []);

  if (formConfig) {
    return (
      <div className="p-4 bg-gray-100 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4">{formConfig.form_name}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {formConfig.fields.map((field, index) => (
            <div key={index} className="mb-4">
              {JSON.stringify(formData)}
              <label className="block mb-1 font-semibold">{field.label}</label>
              <Input
                {...field.attributes}
                value={formData && formData[field?.attributes?.name]}
                onChange={(e) =>
                  handleChange(field.attributes.name, e.target.value)
                }
              />
            </div>
          ))}
          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </form>
      </div>
    );
  }
};

export default FormPreview;
